import React, { useRef, useState } from 'react';
import { Box, Typography, Paper } from '@mui/material';
import ProctoringWidget from '@shaunstapes/proctoring-widget';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Registration page that shows the ProctoringWidget's 3-step designed flow:
 * Step 1: System check (camera, face model, face detected, speech, backend)
 * Step 2: Face capture
 * Step 3: ID verification
 * 
 * When registration completes, navigates back to the exam.
 */
const RegistrationPage = () => {
  const widgetRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [start] = useState(false);

  const query = new URLSearchParams(location.search);
  const userId = query.get('userId') || '';
  const examId = query.get('examId') || '';

  const handleRegistrationComplete = () => {
    navigate(`/?userId=${userId}&examId=${examId}`, { replace: true });
  };

  if (!userId || !examId) {
    return (
      <Box sx={{ p: 4, textAlign: 'center' }}>
        <Typography color="text.secondary">
          User ID and Exam ID are required. Please open this page from the exam link.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 2, maxWidth: 900, margin: '0 auto', minHeight: '80vh' }}>
      <Paper elevation={0} sx={{ p: 2, mb: 2, border: '1px solid', borderColor: 'divider' }}>
        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
          Complete Registration
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Follow the steps below to register for proctored exam monitoring. You will need your ID and webcam.
        </Typography>
      </Paper>
      <ProctoringWidget
        ref={widgetRef}
        userId={userId}
        examId={examId}
        start={start}
        runSystemCheck={false}
        requireSystemCheck={true}
        onStartMonitoringClick={handleRegistrationComplete}
        apiBaseUrl={typeof window !== 'undefined' ? window.location.origin : ''}
        websocketUrl={typeof window !== 'undefined' ? window.location.origin : ''}
        examIsActive={false}
        sendTranscriptsToServer={false}
        sendViolationsToServer={false}
        showDebug={false}
        showVideo={true}
      />
    </Box>
  );
};

export default RegistrationPage;
